import request from '@/utils/request'

// 查询首页banner列表
export function listBanner(query) {
  return request({
    url: '/banner/list',
    method: 'get',
    params: query
  })
}

// 查询首页banner详细
export function getBanner(id) {
  return request({
    url: `/banner/info/${id}`,
    method: 'get'
  })
}

// 新增首页banner
export function addBanner(data) {
  return request({
    url: '/banner/save',
    method: 'post',
    data
  })
}

// 修改首页banner
export function updateBanner(data) {
  return request({
    url: '/banner/update',
    method: 'post',
    data
  })
}

// 删除首页banner
export function delBanner(id) {
  const data = [];
  data.push(id);
  return request({
    url: '/banner/delete',
    method: 'post',
    data
  })
}

// 导出首页banner
export function exportBanner(query) {
  return request({
    url: '/banner/export',
    method: 'get',
    params: query
  })
}
